import Vue from "vue";
import Router from "vue-router";

Vue.use(Router);

const router = new Router({
  mode: "history",
  base: process.env.BASE_URL,

  routes: [
    {
      path: "/inicio",
      redirect: "/dashboard/modern-dashboard",
      component: () => import("@/layouts/full-layout/FullLayout"),
      children: [
        {
          name: "Form Group",
          path: "/form-layouts/form-group",
          component: () => import("@/views/form-layouts/FormGroup"),
        },
        {
          name: "Form Row Separator",
          path: "/form-layouts/form-row-separator",
          component: () => import("@/views/form-layouts/FormRowSeparator"),
        },
        {
          name: "Form Bordered",
          path: "/form-layouts/form-bordered",
          component: () => import("@/views/form-layouts/FormBordered"),
        },
        {
          name: "Form Horizontal",
          path: "/form-layouts/form-horizontal",
          component: () => import("@/views/form-layouts/FormHorizontal"),
        },
        {
          name: "Form Striped Row",
          path: "/form-layouts/form-striped-row",
          component: () => import("@/views/form-layouts/FormStripedRow"),
        },
        // icons
        {
          name: "Font Awesome",
          path: "/icons/fontawesome",
          component: () => import("@/views/icons/FontAwesomeIcons"),
        },
        {
          name: "Material",
          path: "/icons/material",
          component: () => import("@/views/icons/MaterialIcons"),
        },
        {
          name: "Simple line",
          path: "/icons/simpleline",
          component: () => import("@/views/icons/SimpleLineIcons"),
        },
        {
          name: "Themify",
          path: "/icons/themify",
          component: () => import("@/views/icons/ThemifyIcons"),
        },
        {
          name: "Feather",
          path: "/icons/feather",
          component: () => import("@/views/icons/FeatherIcons"),
        },
        // dashboard
        {
          name: "Monitoreo",
          path: "/monitoreo",
          component: () =>
            import("@/views/dashboards/monitoreo/Monitoreo"),
        },
        {
          name: "Histórico",
          path: "/historico",
          component: () =>
            import("@/views/dashboards/monitoreo/Historico"),
        },
        {
          name: "Configuración de dispositivos COBAN",
          path: "/configuracionDispositivo",
          component: () =>
            import("@/views/dashboards/monitoreo/ConfiguracionDispositivo"),
        },
        {
          name: "Configuración de dispositivos TKSTAR",
          path: "/configuracionDispositivoTkstar",
          component: () =>
            import("@/views/dashboards/monitoreo/ConfiguracionDispositivoTkstar"),
        },
        {
          name: "Dispositivos",
          path: "/dispositivos",
          component: () =>
            import("@/views/dashboards/dispositivos/Dispositivos"),
        },
        {
          name: "Generar link",
          path: "/ShareLink",
          component: () =>
            import("@/views/dashboards/dispositivos/CompartirLinkDispositivo"),
        },
        {
          name: "Agregar dispositivo",
          path: "/AddDispositivo",
          component: () =>
            import("@/views/dashboards/dispositivos/AddDispositivo"),
        },
        {
          name: "Editar dispositivo",
          path: "/EditDevice",
          component: () =>
            import("@/views/dashboards/dispositivos/EditDispositivo"),
        },
        {
          name: "Geocercas",
          path: "/geocercas",
          component: () =>
            import("@/views/dashboards/geocerca/Geocercas"),
        },
        {
          name: "Agregar geocerca",
          path: "/AddGeocercas",
          component: () =>
            import("@/views/dashboards/geocerca/AddGeocerca"),
        },
        {
          name: "Editar geocerca",
          path: "/EditGeocercas",
          component: () =>
            import("@/views/dashboards/geocerca/EditGeocerca"),
        },
        {
          name: "Estadísticas",
          path: "/estadisticas",
          component: () =>
            import("@/views/dashboards/estadisticas/Estadisticas"),
        },

        {
          name: "Usuarios",
          path: "/usuarios",
          component: () =>
            import("@/views/dashboards/usuarios/Usuarios"),
        },
        {
          name: "Agregar usuario",
          path: "/AddUsuario",
          component: () =>
            import("@/views/dashboards/usuarios/AddUsuario"),
        },
        {
          name: "Editar usuario",
          path: "/EditUser",
          component: () =>
            import("@/views/dashboards/usuarios/EditUsuario"),
        },
        {
          name: "Grupos",
          path: "/grupos",
          component: () =>
            import("@/views/dashboards/grupos/Grupos"),
        },
        {
          name: "Marcas",
          path: "/marcas",
          component: () =>
            import("@/views/dashboards/marcas/Marcas"),
        },
        {
          name: "Agregar marca",
          path: "/AddMarca",
          component: () =>
            import("@/views/dashboards/marcas/AddMarca"),
        },
        {
          name: "Editar marca",
          path: "/EditMarca",
          component: () =>
            import("@/views/dashboards/marcas/EditMarca"),
        },
        {
          name: "Modelos",
          path: "/modelos",
          component: () =>
            import("@/views/dashboards/modelos/Modelos"),
        },
        {
          name: "Agregar modelo",
          path: "/AddModelo",
          component: () =>
            import("@/views/dashboards/modelos/AddModelo"),
        },
        {
          name: "Editar modelo",
          path: "/EditModelo",
          component: () =>
            import("@/views/dashboards/modelos/EditModelo"),
        },
        {
          name: "Bitácora",
          path: "/acciones",
          component: () =>
            import("@/views/dashboards/accionesRealizadas/Acciones"),
        },
        {
          name: "Errores",
          path: "/logerrores",
          component: () =>
            import("@/views/dashboards/logErrores/Errores"),
        },
        {
          name: "Configuraciones",
          path: "/configuraciones",
          component: () =>
            import("@/views/dashboards/configuraciones/ConfiguracionesGenerales"),
        },
      ],
    },
    {
      name: "Login",
      path: "/",
      component: () => import("@/views/authentication/FullLogin"),
    },
    {
      name: "TiendaAciqui",
      path: "/apps",
      component: () =>
        import("@/views/dashboards/tienda/TiendaDescargas"),
    },
    {
      name: "AciquiCompartirLink",
      path: "/aciquicompartirlink/(.*)",
      component: () =>
        import("@/views/dashboards/monitoreo/CompartirLink"),
    },
    {
      name: "Sesion_caducada",
      path: "/sesion_caducada",
      component: () => import("@/views/authentication/ErrorCaducado"),
    },
    {
      path: "/authentication",
      component: () => import("@/layouts/blank-layout/Blanklayout"),
      children: [
        {
          name: "FullLogin",
          path: "fulllogin",
          component: () => import("@/views/authentication/FullLogin"),
        },
        {
          name: "Error",
          path: "error",
          component: () => import("@/views/authentication/Error"),
        },
        {
          name: "Restablecer contrasena",
          path: "/restablecer",
          component: () => import("@/views/authentication/RestablecerContrasena"),
        },
      ],
    },
    {
      path: "/index.html",
      component: () => import("@/views/authentication/Error"),
    },
    {
      path: "/css/",
      component: () => import("@/views/authentication/Error"),
    },
    {
      path: "/js/",
      component: () => import("@/views/authentication/Error"),
    },
    {
      path: "*",
      component: () => import("@/views/authentication/Error"),
    },
    {
      name: "Ayuda",
      path: "/ayuda",
      component: () =>
        import("@/views/dashboards/ayuda/Ayuda"),
    },
  ],
});


/**
 * Permite revisar si existe token o de lo contrario envía al usario al inicio de sesión
 */
router.beforeEach((to, from, next) => {
  const token = sessionStorage.getItem('token');
  const autenticado = !!token; // Convierte a booleano de forma limpia

  // 1. Si ya está logueado e intenta ir al Login, lo mandamos al Monitoreo
  if (to.name === 'Login' && autenticado) {
    return next({ name: 'Monitoreo' });
  }

  // 2. Definimos qué rutas son "públicas" (no requieren token)
  const rutasPublicas = ['Login', 'AciquiCompartirLink', 'Sesion_caducada', 'TiendaAciqui'];
  const esRutaPublica = rutasPublicas.includes(to.name);

  // 3. Si la ruta requiere auth y NO está autenticado
  if (!esRutaPublica && !autenticado) {
    if (from.name !== 'Login') {
      return next({ name: 'Login', params: { mensaje: 'Sesión caducada' } });
    }
    return next();
  }

  // 4. En cualquier otro caso, permitir el paso
  next();
});


router.beforeResolve((to, from, next) => {
  // If this isn't an initial page load.
  if (to.name) {
    // Start the route progress bar.
    //NProgress.start(800);
  }
  next();
});

router.afterEach(() => {
  // Complete the animation of the route progress bar.
  //NProgress.done();
});

export default router;
